import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=22143d9d&"
import script from "@/components/AnimatedNumber/AnimatedNumber.ts?vue&type=script&lang=ts&"
export * from "@/components/AnimatedNumber/AnimatedNumber.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports